import React from 'react';
import { Fade, Modal, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    modalBox: {
        width: '100%',
        height: '100vh',
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    contentBox: {
        backgroundColor: 'white',
        padding: 20,
        borderRadius: 8
    }
});


const CustomModal = ({ open, onClose, children , className=null }) => {

    const classes = useStyles();

    const handleClose = () => {
        onClose();
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-title"
            aria-describedby="transition-modal-description"
            closeAfterTransition
        >
            <Fade in={open}>
                <Box className={classes.modalBox} onClick={handleClose}>
                <div className={`${classes.contentBox} ${className}`} onClick={(event) => event.stopPropagation()}>
                        {children}
                    </div>
                </Box>
            </Fade>
        </Modal>
    );
};

export default CustomModal;
